export const CANVAS_CONTRACT_ADDRESS = '0x3a56AB63c7ef4f07fe353bEb132e0Fd5AD270Ca0';
export const SUB_ART_CONTRACT_ADDRESS = '0xEE7EA2E41d8E130346DFDF5B55E1A36283AA9cd9';
export const TRIM_SVG_LAYERS = 613;
//export const TRIM_SVG_LAYERS = -1;
export const ACTIVATION_GAP_SIZE = 10;
